// extracted by mini-css-extract-plugin
export default {"actions":"_881a8517798bfd79","action":"_66ce78ed160b793b"};